// Os Links LAI herdam esta política: hover/foco com tolerância a passagens rápidas,
// toque imediato e reutilização do preload por 30s. A navegação revalida as guardas.
export const routePreloadOptions = {
  defaultPreload: "intent",
  defaultPreloadDelay: 50,
  defaultPreloadStaleTime: 30_000,
} as const;
